/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const NewByronPhoneGeneral: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4ZM19.76 21V18H6.77002V20H17.77V21C17.77 21.55 17.32 22 16.77 22H6.77002C6.22002 22 5.77002 21.55 5.77002 21V2H17.77V17H19.77V2C19.77 0.9 18.87 0 17.77 0H5.77002C4.67002 0 3.77002 0.9 3.77002 2V21C3.77002 22.65 5.12002 24 6.77002 24H16.77C18.42 24 19.77 22.65 19.77 21H19.76Z'
      fill='currentColor'
    />
  </React.Fragment>
)
